module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-user"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.$route.params.userId) ? _c('p', [_vm._v("Add "), (_vm.type == 'admin') ? _c('span', [_vm._v("admin")]) : _c('span', [_vm._v("basic")]), _vm._v(" user. Enter user details below.")]) : _c('p', [_vm._v("Change "), (_vm.type == 'admin') ? _c('span', [_vm._v("admin")]) : _c('span', [_vm._v("basic")]), _vm._v(" user. Enter user details below.")]), _vm._v(" "), _c('personalDetails', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token,
      "type": _vm.type,
      "onLogout": _vm.onLogout
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b4726a0","hasScoped":true}!./src/components/addUser/addUser.component.html
// module id = 549
// module chunks = 1